import React, { useState, useEffect } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  BackHandler,
} from "react-native";

import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import ButtonLayout from "../components/ButtonLayout";
import makeRequest from "../components/makeRequest";

export default function (props) {
  const [failed, setFailed] = useState(false);
  const [citas, setCitas] = useState([]);
  const loadCitas = () => {
    const request = async () => {
      const response = await makeRequest("citas", "get");
      if (response[0] == 200) {
        setCitas(response[1]);
      }
    };
    request();
  };
  useEffect(() => loadCitas(), []);
  console.log(citas);

  return (
    <BackgroundUser scroll={true}>
      <Logo navigation={props.navigation}></Logo>
      <View>
        <View>
          <Title>Elija instalación</Title>
          {props.route.params.instalaciones.map((e) => (
            <ButtonLayout
              text={e.nombre}
              key={e._id}
              onPress={() => {
                if (
                  !(
                    citas.filter((j) => j.instalacion == e._id).length >=
                    e.maximoCitasPorUsuario
                  )
                )
                  props.navigation.navigate("Paso1Cita", {
                    ...props.route.params,
                    instalaciones: props.route.params.instalaciones.filter(
                      (y) => e._id == y._id
                    )[0],
                  });
                else setFailed(true);
              }}>
              {" "}
            </ButtonLayout>
          ))}
        </View>
        {failed && (
          <Title style={{ fontSize: 13 }}>
            Número máximo de citas alcanzado
          </Title>
        )}
      </View>
    </BackgroundUser>
  );
}
